export enum SortOrder {
  Alphabetical_A_to_Z = "Alphabetical (A to Z)",
  Alphabetical_Z_to_A = "Alphabetical (Z to A)",
  ShudderUserRatingLowToHigh = "Shudder User Rating (Low to High)",
  ShudderUserRatingHighToLow = "Shudder User Rating (High to Low)",
  MetascoreLowToHigh = "Metascore (Low to High)",
  MetascoreHighToLow = "Metascore (High to Low)",
  IMDBScoreHighToLow = "IMDB (High to Low)",
  IMDBScoreLowToHigh = "IMDB (Low to High)",
  ShudderSortOrder = "Shudder Sort Order",
  DateReleasedPastToFuture = "Date Released (Past to Future)",
  DateReleasedFutureToPast = "Date Released (Future to Past)",
}
